import React, { Component } from 'react';
import { HashRouter, Route } from 'react-router-dom';
import Banner from './Banner';
import SideNav from './SideNav';
import GroupItems from './GroupItems';
import './App.css';

class App extends Component {
  constructor() {
    super();
    this.state = {
      commandGroups: [],
      eventGroups: []
    };

    this.updateLinks = () => {
      const links = document.links;

      for (let i = 0, linksLength = links.length; i < linksLength; i++) {
        if (!links[i].hash) {
          links[i].target = '_blank';
        }
      }
      // Scroll to top on hash group change
      var path = window.location.hash;
      var re = /\/(commands|events)\/[^\/]+\/([^\/]+)/i;
      var found = path.match(re);
      if (!found) {
        var element = document.getElementById("content-area");
        element.scrollTop = 0;
      }
    }

    window.addEventListener("hashchange", this.updateLinks, false);
  }

  componentDidMount() {
    // Load the commands.json commands and events data into component state
    const xhr = new XMLHttpRequest();
    xhr.overrideMimeType('application/json');
    xhr.open('GET', 'commands.json', true);
    xhr.onreadystatechange = () => {
      if (xhr.readyState === XMLHttpRequest.DONE && xhr.status === 200) {
        const commandsAndEventsGroups = JSON.parse(xhr.responseText);
        const commandGroups = commandsAndEventsGroups.commandGroups;
        const eventGroups = commandsAndEventsGroups.eventGroups;

        this.setState(() => ({
          commandGroups,
          eventGroups
        }));
      }
    }
    xhr.send(null);
  }

  componentDidUpdate() {
    this.updateLinks();

    // This sends the user to the specified command from the url
    var path = window.location.hash;
    var re = /\/(commands|events)\/[^\/]+\/([^\/]+)/i;
    var found = path.match(re);
    if (found) {
      var element = document.getElementById(found[2]);
      element.scrollIntoView();
    }
  }


  render() {
    const { commandGroups, eventGroups } = this.state;
    return (
      <HashRouter>
        <div className="app">
          <Banner commandGroups={commandGroups} eventGroups={eventGroups} />
          <SideNav commandGroups={commandGroups} eventGroups={eventGroups} />
          
          <div className="content-area" id="content-area">
            <Route exact path="/" render={() => (
              <div>Welcome to GVH Commands and Events!</div>
            )} />

            <Route path="/commands/:group" render={({ match }) => {
              if (!commandGroups || !commandGroups.length) {
                return null;
              }

              const group = commandGroups.filter(group => group.name === match.params.group)[0];

              if (!group) {
                console.error(`Couldn't find command group '${match.params.group}'`, match);
                return null;
              }

              return <GroupItems items={group.values} group={group.name} type="commands" />;
            }} />

            <Route path="/events/:group" render={({ match }) => {
              if (!eventGroups || !eventGroups.length) {
                return null;
              }

              const group = eventGroups.filter(group => group.name === match.params.group)[0];

              if (!group) {
                console.error(`Couldn't find command group '${match.params.group}'`, match);
                return null;
              }

              return <GroupItems items={group.values} group={group.name} type="events" />;
            }} />
          </div>
        </div>
      </HashRouter>
    );
  }
}

export default App;
